// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__UKgry","animloader":"loader_animloader__bK3NI"};